import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TextInputField } from '@brighte/form-components';
import { BusinessDetailsType } from '@brighte/validation';
import { useUserDetails } from '@hooks';
import { Text } from '@spark-web/text';
import { BUSINESS_DETAILS, LABELS } from '@utils';

function ApplicantDetailsFields({
  control,
  setValue,
}: Pick<UseFormReturn<BusinessDetailsType>, 'control' | 'setValue'>) {
  const { FIRST_NAME, MIDDLE_NAME, LAST_NAME } = LABELS;
  const { APPLICANT_DETAILS_FIELDS_DESCRIPTION } = BUSINESS_DETAILS;

  const { data } = useUserDetails();
  const isExistingUser = !!data?.fpSynced;

  useEffect(() => {
    if (isExistingUser) {
      const { firstName, middleName, lastName } = data || {};
      setValue('applicant.firstName', firstName);
      setValue('applicant.middleName', middleName);
      setValue('applicant.lastName', lastName);
    }
  }, [data, isExistingUser]);

  return (
    <>
      <Text>{APPLICANT_DETAILS_FIELDS_DESCRIPTION}</Text>
      <TextInputField
        name="applicant.firstName"
        control={control}
        label={FIRST_NAME}
        FieldProps={{ disabled: isExistingUser }}
      />
      <TextInputField
        name="applicant.middleName"
        FieldProps={{ secondaryLabel: '(Optional)', disabled: isExistingUser }}
        control={control}
        label={MIDDLE_NAME}
      />
      <TextInputField
        name="applicant.lastName"
        control={control}
        label={LAST_NAME}
        FieldProps={{ disabled: isExistingUser }}
      />
    </>
  );
}

export default ApplicantDetailsFields;
